import React from "react";
import Box from "@mui/material/Box";
import {
  Button,
  Divider,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import InputAdornment from "@mui/material/InputAdornment";
import Input from "@mui/material/Input";
import DeliveryDetailsCalender from "./DeliveryDetailsCalender";
import DeliveryTime from "./DeliveryTime";
import DeliveryTo from "./DeliveryTo";

export default function DeliveryDetails({setsubDetails,subDetails}) {
  return (
    <>
      <Box
        sx={{
        
          width: "100%",
          height: {xl: "auto", lg: "auto", md: "auto", sm: "auto", xs: "auto"},
          border: "1px solid #E1E1E6",
          borderRadius: "4px",
          padding: "24px",
          mb:'20px',
        }}
      >
        <Box>
          <Typography sx={{ fontSize: "24px", fontWeight: "600"}}>
            Delivery Details
          </Typography>
        </Box>

        <Box>
          <Typography sx={{ fontSize: "20px", fontWeight: "600", mt: "24px" }}>
            Subscription dates
          </Typography>
        </Box>

        {/* <Box>
        <Input
        id="input-with-icon-textfield"
        // label="TextField"
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              <CalendarMonthIcon />
            </InputAdornment>
          ),
        }}
        variant="standard"
      />
        </Box> */}

        {/* <Box pt="8px" sx ={{display:"flex", flexDirection: "row"}}>

        <Box  
>
          <Input
            fullWidth
            disableUnderline="true"
            placeholder="Select date"
            endAdornment={
              <InputAdornment position="start">
                <CalendarMonthIcon sx={{ color: "#9EA3AE" }} />
              </InputAdornment>
            }
            sx={{
              borderColor: "#E1E1E6",
              border: "1px solid",
              // width: {
              //   xl: "337px",
              //   // lg: "300px",
              //   lg: "100%",
              //   md: "205px",
              //   sm: "45%",
              //   xs: "45%",
              // },
              height: {
                lg: "56px",
                md: "56px",
                // sm: "45%",
                xs: "40px",
              },
              borderRadius: "4px",
              padding: "15px, 24px, 15px, 24px",
              gap: { lg: "16px", md: "16px", sm: "0px", xs: "0px" },
              backgroundColor: "#F6F6F6",
              color: "#9EA3AE",
              paddingLeft: "27.12px",
            }}
          ></Input>
        </Box>

        <Box 
         pl="24px" 
>
          <Input
            fullWidth
            disableUnderline="true"
            placeholder="Select date"
            endAdornment={
              <InputAdornment position="start">
                <CalendarMonthIcon sx={{ color: "#9EA3AE" }} />
              </InputAdornment>
            }
            sx={{
              borderColor: "#E1E1E6",
              border: "1px solid",
              // width: {
              //   xl: "337px",
              //   // lg: "300px",
              //   lg: "100%",
              //   md: "205px",
              //   sm: "45%",
              //   xs: "45%",
              // },
              height: {
                lg: "56px",
                md: "56px",
                // sm: "45%",
                xs: "40px",
              },
              borderRadius: "4px",
              padding: "15px, 24px, 15px, 24px",
              gap: { lg: "16px", md: "16px", sm: "0px", xs: "0px" },
              backgroundColor: "#F6F6F6",
              color: "#9EA3AE",
              paddingLeft: "27.12px",
            }}
          ></Input>
        </Box>
        
        </Box>// */}

        <Box mt="24px" sx={{width:'100%'}}>
            <DeliveryDetailsCalender setsubDetails={setsubDetails} subDetails={subDetails}/>
        </Box>


        <Box><DeliveryTime setsubDetails={setsubDetails} subDetails={subDetails}/></Box>

        <Box><DeliveryTo setsubDetails={setsubDetails} subDetails={subDetails}/></Box>



      </Box>
    </>
  );
}
